import { render, staticRenderFns } from "./DnDisciplineElement.vue?vue&type=template&id=2dd5946e&scoped=true&"
import script from "./DnDisciplineElement.vue?vue&type=script&lang=js&"
export * from "./DnDisciplineElement.vue?vue&type=script&lang=js&"
import style0 from "./DnDisciplineElement.vue?vue&type=style&index=0&id=2dd5946e&lang=scss&scoped=true&"
import style1 from "./DnDisciplineElement.vue?vue&type=style&index=1&id=2dd5946e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5946e",
  null
  
)

export default component.exports